// Lot 589 — état partagé de la carte « Complète ton profil » (comptes inscrits en mode allégé).
export const PROFILE_DONE_DISMISS_KEY = "yalola.profile_done.later";

const dismissed = () => { try { return localStorage.getItem(PROFILE_DONE_DISMISS_KEY) === "1"; } catch { return false; } };

// La carte est à l'écran tant que le profil n'est pas à 100 % et que le membre n'a pas cliqué « Plus tard » une fois
// les obligatoires faits : les autres cartes « photo » / « bio » du fil se taisent alors (une seule demande à la fois).
export const profileCompletionCardVisible = (user) => {
  const pc = user?.profile_completion;
  if (!pc || pc.percent >= 100) return false;
  return !(pc.complete && dismissed());
};

// Profil encore bloqué (genre, ville, rôle, intérêts manquants) : aucune autre procédure (permissions natives…) ne doit
// venir par-dessus cette étape.
export const profileIncomplete = (user) => !!user?.profile_completion && !user.profile_completion.complete;

// Lot 597 — garde à l'ENTRÉE d'une création (publication, photo, story, direct…) : tant que le profil est bloqué, la
// feuille « Complète ton profil » s'ouvre tout de suite au lieu de laisser le membre préparer un envoi qui sera refusé
// (403 profile_incomplete) à la publication. Retourne true si l'action peut continuer.
export const requireCompleteProfile = (user) => {
  if (!profileIncomplete(user)) return true;
  try { window.dispatchEvent(new CustomEvent("yalola:profile_incomplete", { detail: { code: "profile_incomplete", source: "client" } })); } catch { /* noop */ }
  return false;
};

// Lot 598 — props à poser sur la BARRE d'un champ social (commentaire, message, chat de direct) : tant que le profil est
// bloqué, le premier tap / focus n'ouvre pas le clavier mais la feuille « Complète ton profil ». Vide si le profil est OK.
export const profileGateProps = (user) => {
  if (!profileIncomplete(user)) return {};
  const block = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.target?.blur === "function") e.target.blur();
    requireCompleteProfile(user);
  };
  return { onPointerDownCapture: block, onMouseDownCapture: block, onFocusCapture: block, "data-profile-gated": "1" };
};
